// A self-asserted display name, as the rail defines it (backend/rail/display_name.py, #93):
// one service entry in a did:webvh document,
//   {id: "<did>#display-name", type: "https://qseverse.com/ns/rail/v1#DisplayName",
//    serviceEndpoint: {name}},
// the name 1 to 60 characters after trimming, no control (Cc) or format (Cf)
// characters. Anyone can write any name in their own DID document, so it is shown
// only with a "self-asserted" label and never as verified. It is public, and stays
// in the DID's history even after it is removed.
export const DISPLAY_NAME_TYPE = "https://qseverse.com/ns/rail/v1#DisplayName";
export const DISPLAY_NAME_FRAGMENT = "#display-name";
export const MAX_NAME = 60;

const BAD_CHARS = /[\p{Cc}\p{Cf}]/u;

/** null if the rail would accept `name`, else why not (the rail's own wording). */
export function nameProblem(name: unknown): string | null {
  if (typeof name !== "string") return "serviceEndpoint.name must be a string";
  const n = name.trim();
  if (n.length < 1 || n.length > MAX_NAME) return `the display name must be 1 to ${MAX_NAME} characters`;
  if (BAD_CHARS.test(n)) return "the display name may not contain control or format characters";
  return null;
}

/** The document's name, when its entry is well formed (as the rail reads it). */
export function displayNameOf(doc: Record<string, any> | null | undefined): string | null {
  const entries = (doc?.service ?? []).filter((s: any) => s?.type === DISPLAY_NAME_TYPE);
  if (entries.length !== 1 || entries[0].id !== `${doc?.id}${DISPLAY_NAME_FRAGMENT}`) return null;
  const name = entries[0].serviceEndpoint?.name;
  return nameProblem(name) ? null : (name as string).trim();
}

export function withDisplayName(state: Record<string, any>, name: string | null): Record<string, any> {
  const next = JSON.parse(JSON.stringify(state));
  const id = `${next.id}${DISPLAY_NAME_FRAGMENT}`;
  const others = (next.service ?? []).filter((s: any) => s?.type !== DISPLAY_NAME_TYPE && s?.id !== id && s?.id !== DISPLAY_NAME_FRAGMENT);
  if (name) others.push({ id, type: DISPLAY_NAME_TYPE, serviceEndpoint: { name } });
  if (others.length) next.service = others; else delete next.service;
  return next;
}
